import * as React from "react";
export default React.memo(function SvgClose12Px(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" role="presentation" {...props}><path d="m5.997 6.784 4.454 4.359.787-.804-4.43-4.336 4.465-4.3-.78-.81-4.49 4.323L1.55.857l-.787.804 4.43 4.336-4.465 4.3.78.81 4.49-4.323z" /></svg>;
});